module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/VSw7u3vlbG1ADTseR1hak-e1dca703011af2f6285fc2d97463082c.jpg";